const localServerUrl = "http://localhost:8080/";

const productionServerUrl =
  "https://mobility-api-private-dot-mobs-2019-ncov-web.appspot.com/";

export { localServerUrl, productionServerUrl };
